import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'ccl_design_stuttgart',
} as IModuleProps;
